import React, { Component } from 'react'
import Unknown from './Unknown'

export class PageNotFound extends Component {
    render() {
        return <Unknown />
    }
}

export default PageNotFound
